import React from 'react'
import styled from 'styled-components'
import { colors } from '../../Shared/colors'
import { NavLink } from 'react-router-dom'
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { Section } from './sharedSidebarStyles';

export const ClientsSidebar = () => {
    return (
        <>
            <Section>
                <p>
                    Leads
                </p>
                <div>
                    <NavLink end to='clients'>
                        <SearchOutlinedIcon /> <span>Clients</span>
                    </NavLink>
                </div>
            </Section>
        </>
    )
}


// Styled components are now imported from sharedSidebarStyles.js